module.exports = __webpack_public_path__ + "img/homescreen3.fa821544.png";